import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "invitation-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-head pb-3" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "activity-btn" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-angle-left mr-1" }, null, -1)
const _hoisted_9 = { class: "project-body" }
const _hoisted_10 = {
  key: 0,
  class: "bg-light p-3 rounded mb-3"
}
const _hoisted_11 = { class: "chat-inline-list" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-paper-plane" })
], -1)
const _hoisted_13 = {
  key: 1,
  class: "activity-block"
}
const _hoisted_14 = {
  key: 0,
  class: "activity-img"
}
const _hoisted_15 = {
  key: 1,
  class: "activity-img"
}
const _hoisted_16 = {
  key: 2,
  class: "activity-btn"
}
const _hoisted_17 = {
  key: 3,
  class: "activity-btn"
}
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center inner-wrap pb-0" }
const _hoisted_21 = { class: "modal-wrap default-modal" }
const _hoisted_22 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "successModal",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_23 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_24 = { class: "modal-content text-center" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "msg-header" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createVNode("svg", {
      width: "1em",
      height: "1em",
      viewBox: "0 0 16 16",
      class: "bi bi-check-circle",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createVNode("path", {
        "fill-rule": "evenodd",
        d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
      }),
      /*#__PURE__*/_createVNode("path", {
        "fill-rule": "evenodd",
        d: "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
      })
    ])
  ])
], -1)
const _hoisted_26 = { class: "msg-body" }
const _hoisted_27 = { class: "modal-body" }
const _hoisted_28 = { class: "modal-wrap default-modal" }
const _hoisted_29 = {
  class: "modal fade",
  id: "deleteInvitation",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_30 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_31 = { class: "modal-content" }
const _hoisted_32 = { class: "modal-header" }
const _hoisted_33 = {
  class: "modal-title",
  id: "deleteModalLabel"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_35 = { class: "modal-body" }
const _hoisted_36 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_37 = {
  key: 0,
  class: "form-group"
}
const _hoisted_38 = { for: "exampleInputEmail1" }
const _hoisted_39 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_router_link = _resolveComponent("router-link")
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    ((_ctx.state.isLoading && _ctx.pendingList.length == 0) || _ctx.state.postLoading.declineInvitation || _ctx.state.postLoading.acceptInvitation)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('channel_invitation')), 1),
        _createVNode("div", _hoisted_7, [
          (_ctx.pendingList && _ctx.pendingList.length)
            ? (_openBlock(), _createBlock("a", {
                key: 0,
                href: "javascript:void(0)",
                class: "btn default-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.join(_ctx.pendingList)))
              }, _toDisplayString(_ctx.$t('approve_all')), 1))
            : _createCommentVNode("", true),
          (_ctx.pendingList && _ctx.pendingList.length)
            ? (_openBlock(), _createBlock("a", {
                key: 1,
                href: "javascript:void(0)",
                class: "btn secondary-btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDeclineModal(_ctx.pendingList)))
              }, _toDisplayString(_ctx.$t('decline_all')), 1))
            : _createCommentVNode("", true),
          _createVNode("a", {
            href: "javascript:void(0)",
            class: "btn default-btn",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.backInvitation && _ctx.backInvitation(...args)))
          }, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.data.error.errorsList,
          hasError: _ctx.data.error.hasError
        }, null, 8, ["errors", "hasError"]),
        (_ctx.state.data.recentJoinChannel.length)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode("h5", null, _toDisplayString(_ctx.$t('recent_join_channels')), 1),
              _createVNode("div", _hoisted_11, [
                _createVNode("ul", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.recentJoinChannel, (recChannel, recChannelIndex) => {
                    return (_openBlock(), _createBlock("li", {
                      class: "mr-2",
                      key: recChannelIndex
                    }, [
                      _createVNode(_component_router_link, {
                        to: {
                  name: 'admin-channel',
                  params: { channelId: recChannel.channel_uuid },
                }
                      }, {
                        default: _withCtx(() => [
                          _createVNode("button", {
                            class: "chat-bubble-btn",
                            ref: "myButton",
                            "data-toggle": "tooltip",
                            "data-placement": "top",
                            "data-custom-class": "chat-bubble-tooltip",
                            title: recChannel.channel_name
                          }, [
                            _createTextVNode(_toDisplayString(recChannel.channel_name), 1),
                            _hoisted_12
                          ], 8, ["title"])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.pendingList && _ctx.pendingList.length)
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pendingList, (pending, pendingIndex) => {
                return (_openBlock(), _createBlock("div", {
                  class: _ctx.state.data.selectedUuid === pending.uuid ? 'activity-list mb-4 active' : 'activity-list mb-4',
                  key: pendingIndex
                }, [
                  (pending.image)
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        _createVNode("img", {
                          src: pending.image,
                          alt: "",
                          title: pending.email
                        }, null, 8, ["src", "title"])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_15, [
                        _createVNode("img", {
                          src: _ctx.data.imageBaseUrl
                ? `${_ctx.data.imageBaseUrl}img/no-user.jpg`
                : 'img/no-user.jpg'
                ,
                          alt: "",
                          title: pending.email
                        }, null, 8, ["src", "title"])
                      ])),
                  _createVNode("p", null, [
                    _createTextVNode(_toDisplayString(pending.description) + " ", 1),
                    _createVNode("strong", null, _toDisplayString(pending.createdLatest), 1)
                  ]),
                  (pending.type === 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_16, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          class: "btn default-btn",
                          onClick: ($event: any) => (_ctx.join(pending))
                        }, _toDisplayString(pending.isJoinStatus ?
                _ctx.$t('approving') : _ctx.$t('approve')), 9, ["onClick"]),
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          class: "btn secondary-btn",
                          onClick: ($event: any) => (_ctx.showDeclineModal(pending))
                        }, _toDisplayString(pending.isDeclineStatus ? _ctx.$t('declining') : _ctx.$t('decline')), 9, ["onClick"])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_17, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          class: "btn default-btn",
                          onClick: ($event: any) => (_ctx.viewInvitationDetail(pending))
                        }, _toDisplayString(_ctx.$t('view_details')), 9, ["onClick"])
                      ]))
                ], 2))
              }), 128))
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode(_component_EmptyData, {
                  title: _ctx.title,
                  heading: _ctx.heading
                }, null, 8, ["title", "heading"])
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode(_component_router_link, {
                  to: { name: 'admin-dashboard' },
                  class: "btn default-btn outline"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('redirect_to_dashboard')), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
      ])
    ]),
    _createVNode("div", _hoisted_21, [
      _createVNode("div", _hoisted_22, [
        _createVNode("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode("div", _hoisted_26, [
              _createVNode("h3", null, _toDisplayString(_ctx.$t('successful')) + " !", 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 1,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage,
          isButton: true
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_27, [
              (_ctx.state.data.acceptChannel)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn default-btn mr-2 mb-2",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToChannel(_ctx.state.data.acceptChannel.channel_uuid)))
                  }, _toDisplayString(_ctx.$t('go_to_channel')), 1))
                : _createCommentVNode("", true),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn mr-2 mb-2",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToProjectDahboard()))
              }, _toDisplayString(_ctx.$t('go_to_project')), 1)
            ])
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_28, [
      _createVNode("div", _hoisted_29, [
        _createVNode("div", _hoisted_30, [
          _createVNode("div", _hoisted_31, [
            _createVNode("div", _hoisted_32, [
              _createVNode("h5", _hoisted_33, _toDisplayString(_ctx.$t('invitation_decline')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteInvitation && _ctx.hideDeleteInvitation(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_34
              ])
            ]),
            _createVNode("div", _hoisted_35, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.data.error.errorsList,
                hasError: _ctx.state.data.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('decline_invitation_confirmation')) + ". ", 1),
              (_ctx.state.data.declineShareProject)
                ? (_openBlock(), _createBlock("div", _hoisted_37, [
                    _createVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('reason_to_decline')), 1),
                    _withDirectives(_createVNode("input", {
                      type: "email",
                      class: "form-control",
                      id: "description",
                      "aria-describedby": "emailHelp",
                      placeholder: "Reason for Decline the Invitation",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.description = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.description]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_39, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.decline && _ctx.decline(...args)))
              }, _toDisplayString(_ctx.state.data.selectedInvition.isDeclineStatus ? _ctx.$t('declining') : _ctx.$t('decline')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteInvitation && _ctx.hideDeleteInvitation(...args)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}